import React from 'react'
import {Input, Button, Icon} from 'antd'
import './styles.scss'

export default ({new_folder_name, on_cancel, on_create_folder, on_change }) => {
  return (
    <div className='create-folder columnWrap'>

      {/* <Icon type="folder-add" /> */}

      <span className="title">New Folder</span>

      <Input value={new_folder_name} onChange={(e) => on_change(e.target.value)} placeholder="Choose Folder Name" />

      <div>
        <Button onClick={()=> on_cancel()}>Cancel</Button>
        <Button onClick={()=> on_create_folder(new_folder_name)}>Save</Button>
      </div>
    </div>
  )
}
